module.exports = __webpack_public_path__ + "static/media/special-offer-item-1.61abd12a.png";